import { classNames } from "@/react/helpers/twMergeWithCN";

import { MemberRowSkeleton } from "./MemberRowSkeleton";

const MAX_SKELETON_ROW_COUNT = 8;

interface MemberRowsSkeletonProps {
  className?: string;
  count?: number | null;
  rowClassName?: string;
}

export const MemberRowsSkeleton = ({
  className,
  count,
  rowClassName,
}: MemberRowsSkeletonProps) => {
  const rowCount = Math.min(
    count ?? MAX_SKELETON_ROW_COUNT,
    MAX_SKELETON_ROW_COUNT,
  );

  return (
    <div className={classNames("flex flex-col", className ?? "gap-4")}>
      {Array.from({ length: rowCount }, (_, index) => (
        <MemberRowSkeleton key={index} className={rowClassName} />
      ))}
    </div>
  );
};
